export default {
  translation: {
    navigation: {
      features: "Fonctionnalités",
      tutorial: "Tutoriel",
      documentation: "Documentation",
      contact: "Contact"
    },
    homepage: {
      hero: {
        title: "Votre Compagnon de Gestion de Repas",
        subtitle: "Restez en contrôle de votre diabète partout, à tout moment",
        downloadApp: "Télécharger sur",
        availableOn: "Disponible sur"
      },
      features: {
        title: "Fonctionnalités",
        cards: {
          glucose: {
            title: "Suivi de Glycémie",
            description: "Enregistrez et suivez votre taux de sucre dans le sang facilement"
          },
          meals: {
            title: "Planification de Repas",
            description: "Créez des plans de repas adaptés à vos besoins diabétiques"
          },
          reminders: {
            title: "Rappels Médicaments",
            description: "Ne manquez jamais une dose avec nos rappels personnalisables"
          }
        },
        seeMore: "Voir Toutes les Fonctionnalités"
      }
    },
    features: {
      title: "Fonctionnalités",
      cards: {
        glucose: {
          title: "Suivi de Glycémie",
          description: "Enregistrez facilement vos mesures de glycémie"
        },
        meals: {
          title: "Planification de Repas",
          description: "Créez des plans de repas adaptés"
        },
        medication: {
          title: "Rappels Médicaments",
          description: "Ne manquez jamais une dose avec nos rappels personnalisables"
        },
        sync: {
          title: "Synchronisation Multi-appareils",
          description: "Accédez à vos données depuis n'importe quel appareil"
        },
        reports: {
          title: "Rapports Détaillés",
          description: "Générez des rapports de santé complets"
        },
        alerts: {
          title: "Alertes Personnalisées",
          description: "Recevez des notifications lorsque vos niveaux nécessitent une attention"
        }
      }
    },
    contact: {
      title: "Contactez-nous",
      subtitle: "Nous sommes là pour vous aider",
      form: {
        name: "Votre Nom",
        email: "Adresse Email",
        subject: "Sujet",
        message: "Message",
        submit: "Envoyer le Message"
      },
      success: "Message envoyé! Nous vous répondrons bientôt."
    },
    tutorial: {
      title: "Comment ça marche",
      subtitle: "Regardez notre tutoriel rapide pour apprendre à utiliser MANAGEGLI efficacement",
      video: {
        thumbnail: "Tutoriel vidéo MANAGEGLI"
      },
      steps: {
        title: "Guide pas à pas",
        step1: {
          title: "Créez votre compte",
          description: "Inscrivez-vous avec votre email et créez un profil personnalisé"
        },
        step2: {
          title: "Configurez vos paramètres",
          description: "Entrez vos objectifs glycémiques et préférences alimentaires"
        },
        step3: {
          title: "Commencez à enregistrer",
          description: "Ajoutez vos premières mesures et vos repas"
        },
        step4: {
          title: "Analysez vos données",
          description: "Consultez vos tendances et ajustez vos habitudes"
        }
      }
    },
    documentation: {
      title: "Documentation",
      sections: "Sections",
      sidebar: {
        getting_started: "Démarrage",
        features: "Fonctionnalités",
        meal_planning: "Planification des repas",
        glucose_tracking: "Suivi de la glycémie",
        reports: "Rapports",
        faq: "FAQ"
      },
      getting_started: {
        welcome: "Bienvenue sur MANAGEGLI, votre compagnon de gestion de repas pour diabétiques. Ce guide vous aidera à configurer et utiliser l'application efficacement.",
        installation: "Installation",
        installation_text: "Téléchargez l'application depuis l'App Store ou Google Play et suivez les instructions d'installation.",
        initial_setup: "Configuration initiale",
        initial_setup_text: "Après l'inscription, vous serez guidé pour configurer votre profil et vos préférences."
      },
      features: {
        overview: "MANAGEGLI offre un ensemble complet d'outils pour gérer votre diabète au quotidien.",
        real_time_glucose_tracking: "Suivi de glycémie en temps réel",
        meal_planning: "Planification des repas",
        food_database: "Base de données alimentaire",
        medication_reminders: "Rappels de médicaments",
        detailed_reports: "Rapports détaillés",
        device_sync: "Synchronisation multi-appareils",
        secure_sharing: "Partage sécurisé avec les professionnels de santé"
      },
      meal_planning: {
        overview: "Créez facilement des plans de repas équilibrés avec notre outil intuitif.",
        main_features: "Caractéristiques principales",
        personalized_suggestions: "Suggestions de repas personnalisées",
        automatic_carb_calculation: "Calcul automatique des glucides",
        diet_alternatives: "Alternatives pour différents régimes"
      },
      glucose_tracking: {
        overview: "Surveillez votre glycémie efficacement avec nos outils avancés.",
        tracking_features: "Fonctionnalités de suivi",
        easy_recording: "Enregistrement facile des mesures",
        real_time_graphs: "Graphiques en temps réel",
        custom_alerts: "Alertes personnalisables"
      },
      reports: {
        overview: "Générez des rapports détaillés pour suivre vos progrès."
      },
      faq: {
        questions: "Questions fréquentes",
        sync_data: "Comment synchroniser mes données ?",
        sync_data_text: "Connectez-vous à votre compte sur tous vos appareils pour une synchronisation automatique.",
        offline_usage: "L'application fonctionne-t-elle hors ligne ?",
        offline_usage_text: "Oui, vous pouvez utiliser les fonctionnalités de base sans connexion internet."
      }
    },
    footer: {
      tagline: "Prenez le contrôle de votre alimentation et de votre glycémie ! Avec MANAGEGLI, accédez à des repas spécialement conçus pour les diabétiques et suivez votre glycémie en toute simplicité. Faites des choix éclairés, visualisez vos tendances et maintenez un équilibre optimal pour votre santé. Mangez mieux, vivez mieux!",
      social: {
        title: "Social",
        follow: "Suivez-nous sur"
      },
      navigation: "Navigation",
      copyright: "© 2025 MANAGEGLI. Tous droits réservés.",
      company: "By MERCY INNOVATION LAB"
    },
    accessibility: {
      changeLanguage: "Passer en anglais",
      toggleTheme: "Changer le mode sombre/clair",
      mainMenu: "Menu principal"
    }
  }
}